// Renamed from LandingPageQuick.js
import React from 'react';
import LandingPageQuick from './LandingPageQuick';

const QuickSleepFix = () => {
  return <LandingPageQuick />;
};

export default QuickSleepFix;
